import { byPrefixAndName } from '@awesome.me/kit-5c288c4b3f/icons'
import { Button as WDSButton } from '@dv01-inc/waterfall-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Button } from './Button'
import { PressEvent } from 'react-aria-components'

const Promo = ({
  text,
  cta,
  url,
  handleClose,
}: {
  text?: string
  cta?: string
  url?: string
  handleClose?: (e: PressEvent) => void
}) => {
  return (
    <div className="relative bottom-0 right-0 col-start-1 col-end-15 row-start-6 row-end-7 flex w-full gap-1 bg-default-10/10 px-4 py-6 backdrop-blur-md sm:absolute sm:col-auto sm:row-auto sm:w-80 sm:rounded-bl-xl sm:rounded-tl-xl">
      <div>
        <h3 className="mb-5 text-sm leading-6 text-default-lighter">{text}</h3>
        <Button to={url}>{cta}</Button>
      </div>
      <div className="flex-grow-0 text-6xl text-default-50">
        <FontAwesomeIcon icon={byPrefixAndName.fad['file-lines']} />
      </div>
      <WDSButton variant="ghost" onPress={handleClose} aria-label="Close">
        <FontAwesomeIcon
          className="text-default-50"
          icon={byPrefixAndName.fal['xmark']}
          size="2x"
        />
        <span className="sr-only">Close</span>
      </WDSButton>
    </div>
  )
}

export default Promo
